export enum HandleUserOption {
  archive = 'archive',
  reactivate = 'reactivate',
  delete = 'delete',
}
